import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { classNames } from '../../../helpers/classnames.js';
import { isNumber } from '../utils.js';
import { BadgeContent } from '../BadgeContent/BadgeContent.js';

var CounterBody = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, count = _a.count, warning = _a.warning, hideBadgeContent = _a.hideBadgeContent, error = _a.error, size = _a.size, rest = __rest(_a, ["children", "className", "count", "warning", "hideBadgeContent", "error", "size"]);
    var rootClassName = classNames('dsb-counter-root', className);
    return (React.createElement("div", __assign({ "data-testid": "CounterBody" }, rest, { className: rootClassName, ref: ref }),
        children,
        (isNumber(count) || warning) && (React.createElement(BadgeContent, { count: count, error: error, warning: warning, hideBadgeContent: hideBadgeContent, size: size, stanalone: !children }))));
});

export { CounterBody };
